const links = document.querySelectorAll('.navMain a');
const path = window.location.href.match(/(.+)#?/);

[...links].forEach(link => {
  // set focus on hover
  link.addEventListener('mouseenter', () => {
    document.activeElement.blur();
  });

  // close mobile navigation on clicks on anchor links
  link.addEventListener('click', () => {
    const anchorLinkMatch = link.href.match(/(.+)#/);

    console.log(window.location, path, link.href, anchorLinkMatch);

    if (anchorLinkMatch && anchorLinkMatch[1]) {
      if (path[1] === anchorLinkMatch[1]) {
        const page = document.querySelector('#page');

        page.classList.remove('mobile-navigation--visible');
      }
    }
    window.location.href = link.href;
    if(link.href.includes('veranstaltungen#events')) {
      window.location.reload(true);
    }
  });
});

// add history back for link
document.querySelectorAll('.navMain-link .navMain-item-title').forEach(span => {
  if (['Zurück', 'Zurück zur Website'].indexOf(span.innerHTML.trim()) > -1) {
    var returnLink = document.getElementById('returnLinkUrl');

    var currentUrl = new URL(window.location.href);

    if (currentUrl.searchParams.has('ref')) {
      span.parentElement.href = currentUrl.searchParams.get('ref');
    } else if (returnLink) {
      span.parentElement.href = returnLink.value;
    }

    span.parentElement.addEventListener('click', () => {
      if (window.history.length >= 2 && !currentUrl.searchParams.has('ref') && !returnLink) {
        window.history.back();
        return false;
      }
    });
  }
});

export default {};
